/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    clientsAlternatesSms: {
        name: 'clientsAlternatesSms',
        text_cs: '[CS] - Tohle je nejaka SMS pro nahradniky - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaka SMS pro nahradniky - dospecifikuj me',
    },
    clientsAlternatesEmail: {
        name: 'clientsAlternatesEmail',
        text_cs: '[CS] - Tohle je nejaky mail pro nahradniky - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaky mail pro nahradniky - dospecifikuj me',
    },
    clientsClientReservationCanceledSms: {
        name: 'clientsClientReservationCanceledSms',
        text_cs: '[CS] - Tohle je nejaka SMS kvuli zruseni rezerrvace - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaka SMS kvuli zruseni rezervace - dospecifikuj me',
    },
    clientsClientReservationCanceledEmail: {
        name: 'clientsClientReservationCanceledEmail',
        text_cs: '[CS] - Tohle je nejaky mail kvuli zruseni rezerrvace - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaky mail kvuli zruseni rezerrvace - dospecifikuj me',
    },
    clientsLectureCanceledSms: {
        name: 'clientsLectureCanceledSms',
        text_cs: '[CS] - Tohle je nejaka SMS ze lekce byla zrusena - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaka SMS ze lekce byla zrusena - dospecifikuj me',
    },
    clientsLectureCanceledEmail: {
        name: 'clientsLectureCanceledEmail',
        text_cs: '[CS] - Tohle je nejaky mail ze lekce byla zrusena - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaky mail ze lekce byla zrusena - dospecifikuj me',
    },
    studioClientCanceledReservationSms: {
        name: 'studioClientCanceledReservationSms',
        text_cs: '[CS] - Tohle je nejaka SMS ze klient zrusil rezeravaci - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaka SMS ze klient zrusil rezeravaci - dospecifikuj me',
    },
    studioClientCanceledReservationEmail: {
        name: 'studioClientCanceledReservationEmail',
        text_cs: '[CS] - Tohle je nejaky mail ze klient zrusil rezeravaci - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaky mail ze klient zrusil rezeravaci - dospecifikuj me',
    },
    studioClientCreatedReservationSms: {
        name: 'studioClientCreatedReservationSms',
        text_cs: '[CS] - Tohle je nejaky SMS ze klient vytvoril rezeravaci - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaky SMS ze klient vytvoril rezeravaci - dospecifikuj me',
    },
    studioClientCreatedReservationEmail: {
        name: 'studioClientCreatedReservationEmail',
        text_cs: '[CS] - Tohle je nejaky mail ze klient vytvoril rezeravaci - dospecifikuj me',
        text_en: '[EN] - Tohle je nejaky mail ze klient vytvoril rezeravaci - dospecifikuj me',
    },
};
